import { HideIfNotLoggedIn } from '../../../functional/HideIfNotLoggedIn';
import { DeskTopMenu } from './DeskTopMenu';
import { HamburgerButton } from './HamburgerButton';
import { SiteLogo } from './SiteLogo';
import type { Config } from 'u-next/config';

export const Header: React.FC<{
  options: Config;
}> = ({ options }) => (
  <div>
    <header className="relative h-14 w-full bg-base-100">
      <SiteLogo options={options} />
      <HideIfNotLoggedIn>
        <div className="hidden lg:block">
          <DeskTopMenu options={options} />
        </div>
        <div className="block lg:hidden">
          <HamburgerButton />
        </div>
      </HideIfNotLoggedIn>
      <div className="absolute inset-x-0 bottom-0 h-[1px] w-full bg-main-10" />
    </header>
  </div>
);
